import { track } from '@amplitude/analytics-browser';

export function trackFilters<T extends object>(filtersApplied: T) {
  if (Object.keys(filtersApplied).length !== 0) {
    track('FiltersApplied', {
      filtersApplied,
    });
  }
}
